module.exports = __webpack_public_path__ + "media/images/sort-asc-581dd2b17ef96f3cd66d9377ea51df95.svg";